enum TabKeys {
    Create = 'Create',
    List = 'List',
}

export default TabKeys;
